// extracted by mini-css-extract-plugin
export default {"logo":"Style_logo__CRV5L","banner":"Style_banner__QET5l","panel":"Style_panel__S6cHd","rotate":"Style_rotate__74Ygz"};